<template>
    <div>
        <div class="content">
            <form @submit.prevent="getData">
                <div class="row">
                    <div class="col">
                        <label>Säljare</label><br />
                        <b-form-select
                            v-model="data_request_filter.sales_rep_user_id"
                            :options="sales_reps"
                            :class="{ 'border-warning': selectedSellerNotInRange }"
                        ></b-form-select>
                        <small v-if="selectedSellerNotInRange" class="text-warning">
                            <i class="icon-warning2"></i>
                            Vald säljare har inga ordrar i datumintervallet
                        </small>
                    </div>
                    <div class="col">
                        <label>Datumintervall</label><br />
                        <v-date-picker
                            v-model="date"
                            mode="date"
                            :locale="{
                                id: 'sv',
                                firstDayOfWeek: 2,
                                masks: { weekdays: 'WW', input: 'YYYY-MM-DD' },
                            }"
                            :model-config="{
                                type: 'string',
                                mask: 'YYYY-MM-DD',
                            }"
                            is-range
                            show-iso-weeknumbers
                        >
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="row">
                                    <div class="col" style="position: relative">
                                        <div class="input-group">
                                            <span class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i
                                                        class="icon-calendar2"
                                                    ></i>
                                                </span>
                                            </span>
                                            <input
                                                class="form-control"
                                                :value="inputValue.start"
                                                v-on="inputEvents.start"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="
                                            flex-shrink-1
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <i class="icon-arrow-right8"></i>
                                    </div>
                                    <div class="col" style="position: relative">
                                        <div class="input-group">
                                            <span class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i
                                                        class="icon-calendar2"
                                                    ></i>
                                                </span>
                                            </span>
                                            <input
                                                class="form-control"
                                                :value="inputValue.end"
                                                v-on="inputEvents.end"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </v-date-picker>
                    </div>
                    <div class="col">
                        <label>&nbsp;</label><br />
                        <button
                            type="submit"
                            class="form-control btn btn-primary"
                        >
                            <span v-if="busy_loading"
                                ><i class="spinner icon-spinner"></i></span
                            ><span v-else>Visa rapport</span>
                        </button>
                    </div>
                </div>
                <div class="mt-3">
                    Snabbfilter:
                    <small class="text-muted ml-2">Klicka för att inkludera (grön) eller exkludera (röd). Allt grått = visa allt.</small>
                </div>
                <div class="row mt-1">
                    <div class="col">
                        <button
                            v-for="(label, key) in quickFilterLabels"
                            :key="key"
                            @click.prevent="cycleFilter(key)"
                            :class="{
                                btn: true,
                                'btn-secondary': table_render_filter[key] === null,
                                'btn-success': table_render_filter[key] === 'include',
                                'btn-danger': table_render_filter[key] === 'exclude',
                                'mr-1': true,
                                'mb-1': true,
                            }"
                            :title="filterTitle(key)"
                        >
                            {{ label }}
                        </button>
                        <button
                            @click.prevent="resetFilters()"
                            class="btn btn-light ml-5"
                            title="Rensa alla filter"
                        >
                            <i class="icon-reset"></i> Rensa
                        </button>
                    </div>
                </div>
            </form>

            <div class="card mt-2">
                <rednax-datatable
                    :data="filteredTableData"
                    :columns="table_columns"
                    :filter="data_request_filter"
                    @rowclick="rowClick"
                    :per-page="10"
                    history
                    sort-by="OrderID"
                    sort-order="asc"
                    size="xs"
                    ref="tblcardorder"
                >
                    <template #cell_StatusID="{ row }">
                        <span
                            class="badge"
                            :class="[
                                'badge-' +
                                    (order_statuses[row.StatusID]
                                        ? order_statuses[row.StatusID].color
                                        : 'secondary'),
                            ]"
                        >
                            {{
                                order_statuses[row.StatusID]
                                    ? order_statuses[row.StatusID].label
                                    : row.StatusID
                            }}
                        </span>
                    </template>
                    <template #cell_PaymentStatusID="{ row }">
                        <span
                            class="badge"
                            :class="[
                                'badge-' +
                                    (payment_statuses[row.PaymentStatusID]
                                        ? payment_statuses[row.PaymentStatusID]
                                              .color
                                        : 'secondary'),
                            ]"
                        >
                            {{
                                payment_statuses[row.PaymentStatusID]
                                    ? payment_statuses[row.PaymentStatusID]
                                          .label
                                    : row.PaymentStatusID
                            }}
                        </span>
                    </template>
                    <template #cell_DeliveryStatusID="{ row }">
                        <span
                            class="badge"
                            :class="[
                                'badge-' +
                                    (delivery_statuses[row.DeliveryStatusID]
                                        ? delivery_statuses[
                                              row.DeliveryStatusID
                                          ].color
                                        : 'secondary'),
                            ]"
                        >
                            {{
                                delivery_statuses[row.DeliveryStatusID]
                                    ? delivery_statuses[row.DeliveryStatusID]
                                          .label
                                    : row.DeliveryStatusID
                            }}
                        </span>
                    </template>
                    <template #cell_CompanyName="{ row }">
                        <span
                            :class="{
                                'text-info':
                                    row.CustomerGroupID != 101 || row.ramavtal,
                            }"
                        >
                            {{ row.CompanyName }}
                        </span>
                        <i
                            v-if="row.CustomerGroupID != 101"
                            class="text-muted text-smaller"
                        >
                            / {{ row.CustomerGroup }}</i
                        >
                        <i v-if="row.ramavtal" class="text-muted text-smaller">
                            / Ramavtalskund</i
                        >
                    </template>
                    <template #cell_count_card_on_order="{ row }">
                        {{ formatNumber(row.count_card_on_order) }} st
                    </template>
                    <template #cell_count_card_redeemed="{ row }">
                        {{ formatNumber(row.count_card_redeemed) }} st
                    </template>
                    <template #cell_invoice_amount="{ row }">
                        <span
                            :class="{
                                'text-danger': row.invoice_amount < 0,
                                'text-warning': row.invoice_amount == 0,
                                'text-bold': row.invoice_amount < 0,
                                'font-italic':
                                    row.invoice_source !== 'invoices',
                                'text-info': row.invoice_source !== 'invoices',
                            }"
                        >
                            {{ formatNumber(row.invoice_amount) }}:-
                        </span>
                    </template>
                    <template #cell_commission_special="{ row }">
                        <div
                            v-if="row.comission_special_order != null"
                            class="text-nowrap"
                        >
                            Order:
                            {{ formatNumber(row.comission_special_order) }}:-
                        </div>
                        <div
                            v-if="row.comission_special_card != null"
                            class="text-nowrap"
                        >
                            Kort:
                            {{ formatNumber(row.comission_special_card) }}:-
                        </div>
                        <div v-if="row.comment" class="text-nowrap">
                            {{ row.comment }}
                        </div>
                    </template>
                    <template #cell_TB_100_Percent="{ row }">
                        {{ formatNumber(row.TB_100_Percent, 2) }}%
                    </template>
                    <template #cell_TB_100_Money="{ row }">
                        {{ formatNumber(row.TB_100_Money) }}:-
                        <span
                            v-if="row.grouped_count_card_redeemed > 0"
                            class="text-danger text-"
                            >*</span
                        >
                    </template>
                    <template #cell_commission_per_card="{ row }">
                        {{ formatNumber(row.commission_per_card) }}:-
                    </template>
                    <template #cell_commission="{ row }">
                        {{ formatNumber(row.commission) }}:-
                    </template>
                    <template #cell_warning="{ row }">
                        <i
                            v-if="row.warning"
                            :class="{
                                icon: true,
                                'icon-warning': true,
                                'text-warning': !row.warning_cleared,
                                'text-success': row.warning_cleared,
                            }"
                            :title="row.warning_msg"
                        ></i>
                    </template>
                    <template #cell_commission_percent="{ row }">
                        {{ formatNumber(row.commission_percent, 2) }}%
                    </template>

                    <template #tfoot>
                        <tr
                            v-if="
                                filteredTableData.length !== table_data.length
                            "
                        >
                            <th class="text-right text-nowrap">Urval:</th>
                            <th class="text-nowrap">
                                {{ formatNumber(filteredTotalsCountOrder) }} st
                            </th>

                            <th colspan="3"></th>

                            <th class="text-right">
                                {{ filteredTotalsCountCardOnOrder }} st
                            </th>
                            <th class="text-right">
                                {{ filteredTotalsCountCardRedeemed }} st
                            </th>
                            <th class="text-right">
                                {{
                                    formatNumber(filteredTotalsInvoiceAmount)
                                }}:-
                            </th>

                            <th colspan="5"></th>

                            <th class="text-right">
                                {{ formatNumber(filteredTotalsTBMoney) }}:-
                            </th>
                            <th class="text-right">
                                {{ formatNumber(filteredTotalsComission) }}:-
                            </th>
                            <th></th>
                            <th></th>
                            <th class="text-right">
                                {{
                                    formatNumber(
                                        filteredTotalsComissionPercent,
                                        2
                                    )
                                }}%
                            </th>
                        </tr>
                        <tr>
                            <th class="text-right text-nowrap">Totalt:</th>
                            <th class="text-nowrap">
                                {{ formatNumber(totals.count_order) }} st
                            </th>

                            <th colspan="3"></th>

                            <th class="text-right">
                                {{ totals.count_card_on_order }} st
                            </th>
                            <th class="text-right">
                                {{ totals.count_card_redeemed }} st
                            </th>
                            <th class="text-right">
                                {{ formatNumber(totals.invoice_amount) }}:-
                            </th>

                            <th colspan="5"></th>

                            <th class="text-right">
                                {{ formatNumber(totals.TB_100_Money) }}:-
                            </th>
                            <th class="text-right">
                                {{ formatNumber(totals.commission) }}:-
                            </th>
                            <th></th>
                            <th></th>
                            <th class="text-right">
                                {{
                                    formatNumber(totals.commission_percent, 2)
                                }}%
                            </th>
                        </tr>
                    </template>
                </rednax-datatable>
            </div>

            <!--            <div class="card">-->
            <!--                <div class="card-header" @click="ui.show_raw = !ui.show_raw">-->
            <!--                    <h6 class="card-title">METADATA</h6>-->
            <!--                </div>-->
            <!--                <div class="card-body" v-if="ui.show_raw">-->
            <!--                    <pre>{{ table_data }}</pre>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
        <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { hasPermission } from '@services/Helpers';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import BackendRepository from '@services/repositories/BackendRepository';
import { keyBy } from 'lodash';

export default {
    name: 'CommissionsReport',
    components: {
        RednaxDatatable,
        VDatePicker,
    },
    data: () => ({
        busy_loading: false,
        date: false,
        ui: {
            show_raw: false,
        },
        sales_reps: [{ value: 0, text: ' - ALLA -' }],
        data_request_filter: {
            search: '',
            sales_rep_user_id: 0,
            date_start: null,
            date_end: null,
            showhidden: 0,
            // per_page: 999,
            // sort_by_column: 'FullName',
            // sort_by_order: 'asc',
        },
        quickFilterLabels: {
            children: 'Underliggande',
            warnings: 'Varningar',
            warnings_cleared: 'Godkända varningar',
            grouped: 'Grupperade',
            zero: 'Nollor',
            credit: 'Kreditar',
            offers: 'Offerter',
            neutral: 'Övriga',
        },
        table_render_filter: {
            neutral: null,
            zero: null,
            children: null,
            grouped: null,
            warnings: null,
            warnings_cleared: null,
            credit: null,
            offers: null,
        },
        payment_statuses: [],
        delivery_statuses: [],
        order_statuses: [],
        totals: {},
        table_data: [],
        table_columns: [
            {
                header: '#',
                data: 'OrderID',
                sortable: true,
            },
            {
                header: 'Datum',
                data: 'CreatedTS',
                sortable: true,
                class: 'text-nowrap',
            },
            {
                header: 'Säljare',
                data: 'SellerName',
                sortable: true,
            },
            {
                header: 'Kund',
                data: 'CompanyName',
                sortable: true,
            },
            {
                header: 'Leverans',
                data: 'DelivCompany',
                sortable: true,
            },
            // {
            //     header: 'Referens',
            //     data: 'CustomerRef',
            //     sortable: true,
            // },
            {
                header: 'Antal kort',
                data: 'count_card_on_order',
                sortable: true,
                align_right: true,
            },
            {
                header: 'Inlösta kort',
                data: 'count_card_redeemed',
                sortable: true,
                align_right: true,
            },
            {
                header: 'Fakturerat',
                data: 'invoice_amount',
                sortable: true,
                align_right: true,
            },
            {
                header: 'Orderstatus',
                data: 'StatusID',
                sortable: true,
            },
            {
                header: 'Leveransstatus',
                data: 'DeliveryStatusID',
                sortable: true,
            },
            {
                header: 'Betalstatus',
                data: 'PaymentStatusID',
                sortable: true,
            },
            {
                header: 'Special',
                data: 'commission_special',
                sortable: true,
            },
            {
                header: 'TB Trend',
                data: 'TB_100_Percent',
                sortable: true,
                align_right: true,
            },
            {
                header: 'TB Trend Kr',
                data: 'TB_100_Money',
                sortable: true,
                align_right: true,
            },
            {
                header: 'Provision',
                data: 'commission',
                sortable: true,
                align_right: true,
            },
            {
                header: 'per kort',
                data: 'commission_per_card',
                sortable: true,
                align_right: true,
            },
            {
                header: '⚠️',
                data: 'warning',
                sortable: true,
                align_right: true,
            },
            {
                header: '',
                data: 'commission_percent',
                sortable: true,
                align_right: true,
            },
        ],
    }),
    computed: {
        selectedSellerNotInRange() {
            if (this.data_request_filter.sales_rep_user_id === 0) return false;
            const selected = this.sales_reps.find(
                (s) => s.value === this.data_request_filter.sales_rep_user_id,
            );
            return selected?.outOfRange === true;
        },
        filteredTableData() {
            const f = this.table_render_filter;
            const cats = {
                children:        (item) => !!item.parent_order_id,
                zero:            (item) => !item.commission,
                warnings:        (item) => !!(item.warning && !item.warning_cleared),
                warnings_cleared:(item) => !!item.warning_cleared,
                credit:          (item) => item.invoice_amount < 0,
                offers:          (item) => item.StatusID === 30,
                grouped:         (item) => !!item.grouped_count_card_redeemed,
            };
            const isNeutral = (item) => !Object.values(cats).some((fn) => fn(item));
            const hasIncludes = Object.keys(f).some((k) => f[k] === 'include');

            return this.table_data.filter((item) => {
                // Excludes always win
                for (const [key, fn] of Object.entries(cats)) {
                    if (f[key] === 'exclude' && fn(item)) return false;
                }
                if (f.neutral === 'exclude' && isNeutral(item)) return false;

                // If no includes active: show everything not excluded
                if (!hasIncludes) return true;

                // Show only items matching at least one include
                for (const [key, fn] of Object.entries(cats)) {
                    if (f[key] === 'include' && fn(item)) return true;
                }
                return f.neutral === 'include' && isNeutral(item);
            });
        },
        filteredTotalsCountOrder() {
            return this.filteredTableData.length;
        },
        filteredTotalsCountCardOnOrder() {
            let total = 0;
            this.filteredTableData.forEach((row) => {
                total += row.count_card_on_order;
            });
            return total;
        },
        filteredTotalsCountCardRedeemed() {
            let total = 0;
            this.filteredTableData.forEach((row) => {
                total += row.count_card_redeemed;
            });
            return total;
        },
        filteredTotalsInvoiceAmount() {
            let total = 0;
            this.filteredTableData.forEach((row) => {
                total += row.invoice_amount;
            });
            return total;
        },
        filteredTotalsTBMoney() {
            let total = 0;
            this.filteredTableData.forEach((row) => {
                total += row.TB_100_Money;
            });
            return total;
        },
        filteredTotalsComission() {
            let total = 0;
            this.filteredTableData.forEach((row) => {
                total += row.commission;
            });
            return total;
        },
        filteredTotalsComissionPercent() {
            return this.filteredTotalsTBMoney / this.filteredTotalsComission;
        },
    },
    mounted() {
        this.getStatuses();
        this.resetData();
        const today = new Date();

        const dateStart = new Date(today.getFullYear(), 0, 1);

        const dateEnd = new Date(today.getFullYear(), 11, 31);

        this.date = {
            start: dateStart.toLocaleString('sv-SE').substring(0, 10),
            end: dateEnd.toLocaleString('sv-SE').substring(0, 10),
        };
    },
    methods: {
        hasPermission,
        getStatuses() {
            BackendRepository.getCardOrderPaymentStatuses().then((res) => {
                this.payment_statuses = keyBy(res, 'id');
            });
            BackendRepository.getCardOrderDeliveryStatuses().then((res) => {
                this.delivery_statuses = keyBy(res, 'id');
            });
            BackendRepository.getCardOrderOrderStatuses().then((res) => {
                this.order_statuses = keyBy(res, 'id');
            });
        },
        getSellers() {
            const previouslySelected = this.sales_reps.find(
                (s) => s.value === this.data_request_filter.sales_rep_user_id,
            );
            apiClient
                .get('/vue/economy/commissionreport/sellers', {
                    params: {
                        date_start: this.data_request_filter.date_start,
                        date_end: this.data_request_filter.date_end,
                    },
                })
                .then((response) => {
                    const newList = response.data;
                    const selectedInNewList = newList.find(
                        (s) => s.value === this.data_request_filter.sales_rep_user_id,
                    );
                    if (!selectedInNewList && previouslySelected && previouslySelected.value !== 0) {
                        newList.push({ ...previouslySelected, outOfRange: true });
                    }
                    this.sales_reps = [{ value: 0, text: ' - ALLA -' }, ...newList];
                });
        },
        getData() {
            this.busy_loading = true;
            this.resetData();
            this.getSellers();
            apiClient
                .get('/vue/economy/commissionreport', {
                    params: this.data_request_filter,
                })
                .then((response) => {
                    this.table_data = response.data.table_data;
                    this.totals = response.data.totals;
                })
                .finally(() => {
                    this.busy_loading = false;
                    this.$refs.tblcardorder.reload();
                });
        },
        rowClick(data) {
            window.open('/cardorders/' + data.OrderID);
        },
        formatNumber(number = 0, precision = 0) {
            return parseFloat(number.toFixed(precision)).toLocaleString(
                'sv-SE',
            );
        },
        resetData() {
            this.totals = {
                count_order: 0,
                count_card_on_order: 0,
                count_card_redeemed: 0,
                invoice_amount: 0,
                TB_Now_Money: 0,
                TB_85_Money: 0,
                TB_100_Money: 0,
                commission: 0,
                commission_percent: 0,
            };
            this.table_data = [];
        },
        cycleFilter(key) {
            const current = this.table_render_filter[key];
            if (current === null) this.table_render_filter[key] = 'include';
            else if (current === 'include') this.table_render_filter[key] = 'exclude';
            else this.table_render_filter[key] = null;
        },
        filterTitle(key) {
            const label = this.quickFilterLabels[key];
            const state = this.table_render_filter[key];
            if (state === null) return `${label}: ingen filtrering — klicka för att inkludera`;
            if (state === 'include') return `${label}: visas (inkluderat) — klicka för att exkludera`;
            return `${label}: döljs (exkluderat) — klicka för att rensa`;
        },
        resetFilters() {
            Object.keys(this.table_render_filter).forEach((key) => {
                this.table_render_filter[key] = null;
            });
        },
    },
    watch: {
        'data_request_filter.sales_rep_user_id'(newVal) {
            const selected = this.sales_reps.find((s) => s.value === newVal);
            if (!selected?.outOfRange) {
                this.sales_reps = this.sales_reps.filter((s) => !s.outOfRange);
            }
        },
        date: {
            deep: true,
            handler(date) {
                this.data_request_filter.date_start = date.start;
                this.data_request_filter.date_end = date.end;
                this.getSellers();
            },
        },
    },
};
</script>
